import React from "react";
import Logo from "./Logo";
import heroImage from "../images/stanzetta_2.JPG";
import eventImage from "../images/hover_speakeasy.jpg";
import img1 from "../images/stenzetta_1.JPG";
import img2 from "../images/stanzetta_3.jpg";

export default function SoundRoom() {
  return (
    <div className="bg-white text-black">
      <Logo />

      {/* Main content area with consistent margin */}
      <div className="m-[100px]">
        {/* Hero Section */}
        <div className="relative w-full h-[60vh]">
          <img
            src={img1}
            alt="SoundRoom Hero"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
            <h1 className="text-white text-5xl font-extrabold">LA STANZETTA</h1>
          </div>
        </div>
        <br></br>
        <div className="relative w-full h-[100vh]">
          <img
            src={img2}
            alt="SoundRoom Hero"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Concept Section */}
        <section className="flex flex-col md:flex-row items-center gap-8 mt-16">
          <img
            src={heroImage}
            alt="SoundRoom Experience"
            className="w-full md:w-1/2 rounded-lg shadow-lg"
          />
        </section>
      </div>
    </div>
  );
}
